import { axios } from '@Root/API'

export const update = payload => {
  return axios.put(`accommodations`, payload)
}
